/*
 * The responsiveLoader module is a utility module which allows
 * for selective triggering of interactions based on the browser
 * window's width.
 */

const _breakpoints = Object.freeze({
  sm: 480,
  md: 768,
  lg: 960
});

var _deviceType = 'mobile'; // or 'tablet' or 'desktop'

const updateResponsiveStatus = () => {
  /*
   * we'll use hasBreakpointChanged to check if the window resize is traversing
   * breakpoints. If the breakpoint has changed, we'll emit an event called
   * 'breakpointChanged'. Modules which have breakpoint-specific interactions
   * like the nav module, can have listeners listening for 'breakpointChanged'
   * and proceed to reset states accordingly when the event is fired.
   */
  const oldDevice = _deviceType;

  if (window.innerWidth >= _breakpoints.lg) {
    _deviceType = 'desktop';
  } else if (window.innerWidth >= _breakpoints.md) {
    _deviceType = 'tablet';
  } else {
    _deviceType = 'mobile';
  }

  if (oldDevice !== _deviceType) {
    jQuery(window).trigger('breakpointChanged');
  }
};

function init () {
  updateResponsiveStatus();
  window.addEventListener('resize', updateResponsiveStatus);
}

/*
 * Use the responsiveInteraction function to wrap interaction
 * handlers with a window-size based filter. This utility can
 * disable JS code which handles mobile/tablet interactions
 * (like footer Accordion functionality), which are undesirable
 * in Desktop, but can still be accidentally triggered by the
 * user since the elements are visible.
 *
 * Params
 * ======
 * deviceTypes {String | Array} - 'mobile' or 'tablet' or 'desktop' OR a combination eg., ['mobile', 'tablet']
 * callback {function}  - the event handler function which needs to be triggered
 * thisObject {Object}  - the 'this' object passed by the event listener
 * params {any} - the list of parameters to be passed to the callback
 *
 * Usage
 * =====
 * Example: Attach a handler to an event listener for both Tabler and Mobile,
 *
 * window.addEventListener('some-event', function (e) {
 *   responsiveLoader.onDeviceType(['mobile', 'tablet'], function() {
 *     // handle your event here
 *   }, this, e);
 * });
 */
const onDeviceType = function (deviceTypes, callback, thisObject = {}, ...params) {
  if ((typeof deviceTypes === 'string' && deviceTypes === _deviceType) ||
    (deviceTypes instanceof Array && deviceTypes.includes(_deviceType))
  ) {
    (typeof callback === 'function') && callback.call(thisObject, ...params);
  }
};

const isDesktop = () => {
  if (window.innerWidth <= _breakpoints.lg) {
    return false;
  } else {
    return true;
  }
};

const getDeviceType = () => _deviceType;

export default {
  onDeviceType,
  getDeviceType,
  init,
  isDesktop
};
